import { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import Loader from "../../components/Loader";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';
import GlobalSVG from '../../utils/GlobalSVG';
import EuiFactor from '../../components/EuiFactor';

const EUIType = () => {

    const location = useLocation();
    const [model, setModel] = useState(null)
    const [getPutPost, setGetPutPost] = useState()
    const [modelData, setModelData] = useState({ building_type: ""})
    const [factors, setFactors] = useState()
    const [error, setError] = useState(null)
    const [forceUpdate, setForceUpdate] = useState(false)
    const [loading, setLoading] = useState(false)
    const [addValue, setAddValue] = useState(false)
    const context = useContext(AppContext)
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (!context.getUserInfo) return
        let access = ["access_utilities_list", "create_utilities", "update_utilities"]
        if (!access.some(item => context.getUserInfo[item] === true)) {
            navigate('/settings/roles')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.getUserInfo])

    useEffect(() => {
        if (getPutPost === 'put') return
        if (location.pathname === '/eui/create') {
            setGetPutPost('post')
        } else if (queryParams.size !== 0) {
            setModel(queryParams.get('model'))
            setGetPutPost('get')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParams, location])

    useEffect(() => {
        const cancelToken = API.cancelToken();
        if (getPutPost === 'get' && model !== null) {
            setLoading(true)
            
            API.getEuiType(cancelToken, model).then(res => {
                setModelData(res.data)
                setFactors(res.data.factors)
                return
            }).catch(err => {
                console.log(err)
                if (err.message === 'cancelling') return
                let message = 'Please try again later.'
                if (err.response && err.response.data && err.response.data.includes('error')) {
                    message = err.response.data.error
                }
                Swal.fire({
                    title: 'Error.',
                    text: message,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });

            }).finally(f => {
                setLoading(false)
            })
        }
        return () => {
            API.cancel(cancelToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPutPost, model, forceUpdate])

    const updateModel = (e) => {
        const { name, value } = e.target;
        setModelData(prevValue => {
            return {
                ...prevValue,
                [name]: value.trim()
            }
        })
    }

    const postModel = async (e) => {
        if (modelData.building_type === "") {
            setError({ building_type: "Missing Value" })
        } else {
            setLoading(true)
            const cancelToken = API.cancelToken();
            
            let request = null
            try {
                if (getPutPost === 'post') {
                    request = await API.postEuiType(cancelToken, modelData)
                    navigate(`/eui/type?model=${request.data.id}`)
                } else {
                    let payload = Object.fromEntries(Object.entries(modelData).filter(([k]) => ['building_type'].includes(k)));
                    request = await API.putEuiType(cancelToken, model, payload)
                    setGetPutPost('get')
                }
            } catch (err) {
                console.log(err)
                if (err.message === 'cancelling') return
                if (err.response && err.response.data) {
                    if ('general' in err.response.data || 'message' in err.response.data) {
                        Swal.fire({
                            title: 'Error.',
                            text: err.response.data.general,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    } else {
                        setError(err.response.data)
                    }
                }
            } finally {
                setLoading(false)
            }
        }
    }


    return (
        <div className='tablet:p-8 mobile:p-3 min-h-[80vh]'>
            <div className='flex flex-nowrap items-center gap-4 tablet:mb-8 mobile:mb-3 text-base'>
                <Link to="/settings/eui">
                    EUI
                </Link>
                {
                    GlobalSVG.rightArrow()
                }
                <p className='font-medium'>
                    {
                        ['get', 'put'].includes(getPutPost) ? modelData.building_type : "Add Building Type"

                    }
                </p>
            </div>
            <div className='card tablet:p-8 mobile:p-3 min-h-[70vh]'>
                <div className='input-border pb-8 items-center mb-6'>
                    <input
                        placeholder='Building Type'
                        className='text-3xl p-2 outline-none hide-input-background'
                        type="text"
                        name='building_type'
                        disabled={getPutPost === 'get'}
                        defaultValue={modelData.building_type ? modelData.building_type : ""}
                        onChange={updateModel} />
                    {
                        error && error.building_type &&
                        <p className='text-red text-xs p-2'>{error.building_type}</p>

                    }
                </div>
                {
                    loading &&
                    <Loader />
                }               
                {
                    ['get'].includes(getPutPost) &&
                    <div className='w-full flex flex-nowrap justify-end text-green4 p-2.5'>
                        <p className='cursor-pointer' onClick={() => setGetPutPost('put')}>
                            Edit Type
                        </p>
                    </div>
                }
                <div className="flex flex-nowrap items-center justify-end w-full">
                    {
                        ['put'].includes(getPutPost) && !loading &&
                        <div className='mr-8 text-green3 cursor-pointer' onClick={() => setGetPutPost('get')}>
                            Cancel
                        </div>
                    }
                    {
                        getPutPost !== 'get' && modelData.building_type !== "" && !loading && 
                        <button className='submit-button' onClick={postModel}>
                            Save
                        </button>
                    }
                </div>
                {
                    ['get', 'put'].includes(getPutPost) &&
                    <div className='mt-4'>
                        <p className='text-2xl'>Building Type Values</p>
                        {
                            factors && factors.map((e, index) => (
                                <EuiFactor key={index + "euifactor"} setUpdate={setForceUpdate} update={forceUpdate} value={e} />
                            ))
                        }
                        {
                            addValue &&
                            <EuiFactor edit={true} setUpdate={setForceUpdate} open={setAddValue} update={forceUpdate} value={null} modelId={model} />
                        }

                        {addValue ?
                            <div className='w-full border-light-green block mt-8 text-sm text-green4 font-medium cursor-pointer' onClick={() => setAddValue(false)}>
                                Cancel
                            </div>
                            :
                            <div className='w-full border-light-green block mt-8 text-sm text-green4 font-medium cursor-pointer' onClick={() => setAddValue(true)}>
                                <span className='text-lg mr-2'>+</span>
                                Add new value
                            </div>}
                    </div>
                }
            </div>
        </div>
    );
};

export default EUIType;